import { render, staticRenderFns } from "./RedditButton.vue?vue&type=template&id=0612b97c&scoped=true&"
import script from "./RedditButton.vue?vue&type=script&lang=js&"
export * from "./RedditButton.vue?vue&type=script&lang=js&"
import style0 from "./RedditButton.vue?vue&type=style&index=0&id=0612b97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612b97c",
  null
  
)

export default component.exports